// extracted by mini-css-extract-plugin
export default {"root":"tabHeading_root__r0KoO","active":"tabHeading_active__qBS2L","close":"tabHeading_close__Cy7pc"};